import api from './api';

interface DangKyKhamPayload {
    tenBn: string;
    namSinh: number;
    sdt: string;
    diaChi: string;
    ngayDangKyKham: string; // ISO string
    lyDoDenKham: string;
    ghiChu?: string;
}

export const dangKyKham = async (data: DangKyKhamPayload) => {
    return api.post('/public/dang-ky-kham', data);
};
